import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import { commonMessages } from '~/utility/commonMessages';
import genFranchiseOptions from '~/utility/genFranchiseOptions';

/* NOTE:
 * The available teams to choose from will depend on whatever the time frame is set to.
 * In the previous iteration there was a place in the state store to hold the possible team values.
 * The other components don't need to know the options, but only the value so the options should be local state.
 */
const OpponentSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const setOpp = (e, { value }) => {
        dispatch(filterActionCreators.setOpponent(value));
    };

    const statsConfig = useSelector((state) => state.config);
    const franchiseId = useSelector((state) => state.playersAndTeams.report.current.franchiseId);
    const selectedOpp = useSelector((state) => state.playersAndTeams.filter.values.opponent);

    const franchiseOptions = genFranchiseOptions(statsConfig, intl.formatMessage(commonMessages.labels.allOpponents));
    const dropdownOptions = franchiseId
        ? franchiseOptions.filter((obj) => obj.value !== franchiseId)
        : franchiseOptions;
    const value = !selectedOpp ? dropdownOptions[0] : dropdownOptions.find((obj) => obj.value === selectedOpp);

    return (
        <Select
            onOptionChange={setOpp}
            options={dropdownOptions}
            selectedOption={value}
            isSearchEnabled
            optionsBoxAriaLabel=""
            dropdownButtonAriaLabel=""
        />
    );
};

export default React.memo(OpponentSelect);
